import { omitBy } from "lodash";
export default (function (rawPermissions) {
    var permissions = omitBy(rawPermissions, function (p) { return !p; });
    return (Object.keys(permissions).length <= 0) ? null : permissions;
});
